import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";

export const ReturnAllOrderPage = () => {
  return <OrderListTable status={ShippingStatus.RETURN}/>;
}
